
import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import UserSettings from "@/views/Settings/UserSettings.vue";
import CustomerSettings from "@/views/Settings/CustomerSettings.vue";
import AddressesOverview from "@/views/Settings/AddressesOverview.vue";
import { AddressType } from "@/dtos/addressType";
import { ErpAddressType } from "@/dtos/erpAddressType";

@Component({
	components: {
		UserSettings,
		CustomerSettings,
		AddressesOverview,
	},
})
export default class Settings extends Vue {
	@Prop()
	private tabName!: string;

	private tab = 0;
	private deliveryType: ErpAddressType = ErpAddressType.Delivery;
	private invoiceType: ErpAddressType = ErpAddressType.Invoice;

	private get tabTypes(): { key: string; display: string }[] {
		return [
			{
				key: "user",
				display: this.$t("settings.tabs.user") as string,
			},
			{
				key: "customer",
				display: this.$t("settings.tabs.customer") as string,
			},
			{
				key: "delivery",
				display: this.$t("settings.tabs.delivery") as string,
			},
			{
				key: "invoice",
				display: this.$t("settings.tabs.invoice") as string,
			},
		];
	}

	private mounted() {
		if (this.tabName && this.tabTypes.some((type: any) => type.key === this.tabName)) {
			this.tab = this.tabTypes.findIndex((type: any) => type.key === this.tabName);
		}
	}
}
